import React, { useEffect, useState } from 'react'
import InputBase from '@material-ui/core/InputBase';
import IconButton from '@material-ui/core/IconButton';
import { useChromeInputStyles } from '@mui-treasury/styles/input/chrome';
import EmailTwoToneIcon from "@material-ui/icons/EmailTwoTone"
import { makeStyles } from '@material-ui/core/styles';
import LoginController from "../../../../common/login/LoginController"
import LoginEmailSentDialog from "../unused/LoginEmailSentDialog"
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';
import Button from '@material-ui/core/Button'



const useStyles = makeStyles((theme) =>({
    longInput: {
        minWidth: "500px",
        backgroundColor: '#F1F3F4',
        borderRadius: 100,
        padding: "2px",
        margin: "0 auto",
        [theme.breakpoints.down('xs')]: {
            display: 'none',
        },
    },
    shortInput: {
        width: "100%",
        backgroundColor: '#F1F3F4',
        borderRadius: 100,
        padding: "2px",
        margin: "0 auto",
        [theme.breakpoints.up('sm')]: {
            display: 'none',
        },
    },
    form: {
        margin: "0 auto 20px auto",
        display: "flex",
        width: "100%",
        maxWidth: "40rem",
        position: "relative"
    },
    submitButton: {
        fontSize: "1rem",
        borderRadius: "0 50px 50px 0",
        backgroundColor: "#eea849",
        paddingLeft: 20,
        [theme.breakpoints.down('xs')]: {
            paddingLeft: 12,
        },
        '&:hover': {
            backgroundColor: "#b87917"
        }
    }
}))

const SignupTerminalInput = ({chunkUid}) => {
    const [openConfirmation, setOpenConfirmation] = useState(false)
    const [value, setValue] = useState("")


    const handleEmailSent = () => {
        setOpenConfirmation(true)
    }

    const handleAlertClose = () => {
        setOpenConfirmation(false)
    }


    const styles = useChromeInputStyles();
    const classes = useStyles();
    return (
        <div>
            <LoginController sentCallback={handleEmailSent} chunkUid={chunkUid}>
                {({handleSubmit, sent, setControllerSent, setControllerSending, sending}) => {

                    useEffect(() => {
                        if (sent) {
                            setValue("")
                            setControllerSending(false)
                            setControllerSent(false)
                        }
                    }, [sent])



                    const handleChange = (e) => {
                        setValue(e.target.value)
                    }

                    const _handleSubmit = (e) => {
                        e.preventDefault()
                        handleSubmit(value)
                        setControllerSending(true)
                    }

                    return (
                        <form className={classes.form} onSubmit={_handleSubmit}>
                            <InputBase
                                className={classes.longInput}
                                placeholder={'Your email'}
                                value={value}
                                onChange={handleChange}
                                startAdornment={
                                    <IconButton className={styles.icon}>
                                        <EmailTwoToneIcon/>
                                    </IconButton>
                                }
                                endAdornment={
                                    <IconButton className={classes.submitButton} type="submit" disabled={sending && true}>
                                        {sending ? "Sending..." : "Send Magic Login Link"}
                                    </IconButton>
                                }
                            />
                            <InputBase
                                className={classes.shortInput}
                                placeholder={'Your email'}
                                value={value}
                                onChange={handleChange}
                                startAdornment={
                                    <IconButton className={styles.icon}>
                                        <EmailTwoToneIcon/>
                                    </IconButton>
                                }
                                endAdornment={
                                    <IconButton className={classes.submitButton} type="submit" disabled={sending && true}>
                                        {sending ? "Sending..." : "Login"}
                                    </IconButton>
                                }
                            />
                        </form>

                    )
                }}
            </LoginController>
            <Snackbar open={openConfirmation} onClose={handleAlertClose} anchorOrigin={{vertical: "top", horizontal: "center" }}>
                <MuiAlert onClose={handleAlertClose} severity="success" elevation={6} variant="filled">
                    Click the magic link in your inbox to login.
                </MuiAlert>
            </Snackbar>
        </div>
    );
};


export default SignupTerminalInput;
